function makeId(type) {
  return `${type}-${parseInt(
    Math.ceil(Math.random() * Date.now())
      .toPrecision(6)
      .toString()
      .replace(".", "")
  )}`;
}

class RemoteProTabs extends HTMLElement {
  activeTab;
  activeTabIndex = 0;

  static get observedAttributes() {
    return ["displayed"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "displayed" && newValue === "true") {
      this.init(
        this.querySelectorAll("tabs-buttons"),
        this.querySelectorAll("tabs-panels")
      );
    }
  }

  connectedCallback() {
    if (this.mount) return;
    if (!this.id) {
      this.id = makeId("tab");
    }
    const observerContainer = new MutationObserver(() => {
      this.content = document.querySelector(`#${this.id} > tabs-panels`);
      this.buttons = document.querySelector(`#${this.id} > tabs-buttons`);

      if (
        this.content &&
        this.buttons &&
        this.buttons.hasChildNodes() &&
        this.content.hasChildNodes() &&
        this.content.children.length === this.buttons.children.length
      ) {
        this.init(this.buttons, this.content);
        observerContainer.disconnect();
      }
    });
    observerContainer.observe(this, { childList: true, subtree: true });
  }

  showActiveTab = () => {
    this.activeTab.classList.add("tab-hidden");
    const newActiveTab = this.querySelector(
      `tabs-panels > [data-tab-index="${this.activeTabIndex}"][data-tab-id="${this.id}"]`
    );
    const newActiveTabButton = this.buttons.querySelector(
      `[data-tab-index="${this.activeTabIndex}"][data-tab-id="${this.id}"]`
    );

    if (!newActiveTab || !newActiveTabButton) return;
    newActiveTab.classList.remove("tab-hidden");
    this.activeTab = newActiveTab;

    this.activeTabButton.removeAttribute("aria-selected");
    this.activeTabButton.classList.remove("tw-font-bold");
    this.activeTabButton.classList.remove("tw-underline");
    this.activeTabButton = newActiveTabButton;
    newActiveTabButton.setAttribute("aria-selected", "true");
    newActiveTabButton.classList.add("tw-font-bold");
    newActiveTabButton.classList.add("tw-underline");
  };

  init = (buttons, content) => {
    Array.from(buttons.children).forEach((tab, i) => {
      if (i === 0) {
        this.activeTabButton = tab;
        tab.setAttribute("aria-selected", "true");
      }
      tab.setAttribute("data-tab-index", `${i}`);
      tab.setAttribute("data-tab-id", `${this.id}`);
    });

    Array.from(content.children).forEach((tab, i) => {
      if (i === 0) {
        this.activeTab = tab;
      } else {
        tab.classList.add("tab-hidden");
      }
      tab.setAttribute("data-tab-index", `${i}`);
      tab.setAttribute("data-tab-id", `${this.id}`);
    });

    buttons.addEventListener("mouseover", this.onHover, { capture: true });
    buttons.addEventListener("click", this.onClick, { capture: true });
  };

  /**
   * @param {MouseEvent} e
   */
  onHover = (e) => {
    const buttonTarget = e
      .composedPath()
      .find(
        (element) =>
          element.hasAttribute && element.hasAttribute("data-tab-index")
      );

    if (!buttonTarget) {
      return;
    }

    this.activeTabIndex = Number(buttonTarget.getAttribute("data-tab-index"));
    this.showActiveTab();
  };

  /**
   * @param {MouseEvent} e
   */
  onClick = (e) => {
    const buttonTarget = e
      .composedPath()
      .find(
        (element) =>
          element.hasAttribute && element.hasAttribute("data-tab-index")
      );

    if (!buttonTarget) {
      return;
    }

    const href = buttonTarget.getAttribute("href");
    if (href) {
      window.location.href = href; // Navigate to the href link
    }
  };
}

class TabsButtons extends HTMLElement {}
class TabsPanels extends HTMLElement {}

customElements.define("remote-pro-tabs", RemoteProTabs);
customElements.define("tabs-buttons", TabsButtons);
customElements.define("tabs-panels", TabsPanels);
